import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.productSale.index'),
        name: 'productSale.index',
        component: () =>
            import(
                /* webpackChunkName: "productSale" */ '@/views/productSales/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.productSale.breadcrumb.index'),
                    to: null,
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('routes.productSale.create'),
        name: 'productSale.create',
        component: () =>
            import(
                /* webpackChunkName: "productSale" */ '@/views/productSales/Create.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.productSale.breadcrumb.index'),
                    to: '/' + i18n.t('routes.productSale.index'),
                    disable: false,
                },
                {
                    text: i18n.t('routes.breadcrumb.create'),
                    to: null,
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('routes.productSale.edit') + '/:id',
        name: 'productSale.edit',
        component: () =>
            import(
                /* webpackChunkName: "productSale" */ '@/views/productSales/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.productSale.breadcrumb.index'),
                    to: '/' + i18n.t('routes.productSale.index'),
                    disable: false,
                },
                {
                    text: i18n.t('routes.breadcrumb.edit'),
                    to: null,
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
